const HOUR = 3600 * 1000;

export const getRemainingHours = (cycleEnd: number): number => {
  const diff = cycleEnd - Date.now();
  const diffHours = diff / HOUR;

  return Math.round(diffHours);
};
